import AppCard from '@nxsys/components/AppCard';
import AppIconCard from '@nxsys/components/AppIconCard';
import { GetAgencyStatisticsResponse } from '@nxsys/types/api/dashboard';
import { Icons } from '@nxsys/types/icons';
import { useState } from 'react';
import AgencyTimesheetModal, {
  AGENCY_TIMESHEET_MODAL_TYPE,
} from './components/AgencyTimesheetModal';

type Props = {
  loading: boolean;
  data?: GetAgencyStatisticsResponse['data']['timesheet'];
  agencyId: string;
};

const AgencyTimesheets: React.FC<Props> = ({ loading, data, agencyId }) => {
  const [isOpenTotalTimesheetModal, setIsOpenTotalTimesheetModal] =
    useState(false);
  const [
    isOpenAwaitingApprovalTimesheetModal,
    setIsOpenAwaitingApprovalTimesheetModal,
  ] = useState(false);

  const items = [
    {
      title: data?.totalTimesheet,
      description: 'Total Timesheets',
      onClick: () => setIsOpenTotalTimesheetModal(true),
    },
    {
      title: data?.totalAwaitingTimesheet,
      description: 'Awaiting Approval',
      onClick: () => setIsOpenAwaitingApprovalTimesheetModal(true),
    },
  ];

  return (
    <div className="Timesheets h-full">
      <AppCard className="p-[24px] h-full" loading={loading}>
        <div className="flex justify-between items-center mb-[24px]">
          <AppIconCard iconName="IconNoteListCheck" title="Timesheets" />
        </div>
        <div className="space-y-[16px]">
          {items.map((item) => (
            <div
              key={item.title}
              className="border border-[#CDDDD9] dashboard-hover-card rounded-[8px] p-[16px] flex items-center w-full gap-x-[12px]"
              onClick={item.onClick}
            >
              <div className="border-[3px] border-violet-300 rounded-full w-[12px] h-[12px]"></div>
              <div className="flex gap-x-[8px] flex-1 items-center">
                <div className="text-[22px] font-bold">{item.title}</div>
                <div className="text-[14px] font-bold">{item.description}</div>
              </div>
              <Icons.IconArrowRight />
            </div>
          ))}
        </div>
      </AppCard>
      <AgencyTimesheetModal
        isOpen={isOpenTotalTimesheetModal}
        toggle={() => setIsOpenTotalTimesheetModal(false)}
        agencyId={agencyId}
        type={AGENCY_TIMESHEET_MODAL_TYPE.TOTAL}
      />
      <AgencyTimesheetModal
        isOpen={isOpenAwaitingApprovalTimesheetModal}
        toggle={() => setIsOpenAwaitingApprovalTimesheetModal(false)}
        agencyId={agencyId}
        type={AGENCY_TIMESHEET_MODAL_TYPE.AWAITING_APPROVAL}
      />
    </div>
  );
};

export default AgencyTimesheets;
